import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";

/**
 * Scene 08 — The pivot. "And yet… In property… We're barely scratching the surface."
 * Three-beat reveal that lands the problem we're about to solve.
 */
export default function Scene08_AndYet() {
  return (
    <SceneShell variant="forest" align="left" data-testid="scene-and-yet">
      {/* Background fade — starts rich, shifts subtly toward darker as the line lands */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 30% 30%, rgba(150,193,31,0.18) 0%, transparent 55%)",
            "radial-gradient(ellipse at 70% 70%, rgba(139,26,46,0.14) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 7, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1600px] mx-auto w-full">
        {/* Beat 1 — "And yet…" */}
        <motion.h2
          initial={{ opacity: 0, x: -32, filter: "blur(8px)" }}
          animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.0, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-[40px] sm:text-[64px] lg:text-[88px] text-white/55 leading-[0.95]"
          data-testid="and-yet-line-1"
        >
          And yet…
        </motion.h2>

        {/* Beat 2 — "In property…" */}
        <motion.h2
          initial={{ opacity: 0, x: -32, filter: "blur(8px)" }}
          animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.0, delay: 1.5, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-[44px] sm:text-[72px] lg:text-[100px] text-white/85 leading-[0.95] mt-4"
          data-testid="and-yet-line-2"
        >
          In property…
        </motion.h2>

        {/* Beat 3 — "We're barely scratching the surface." */}
        <motion.h2
          initial={{ opacity: 0, y: 40, filter: "blur(14px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.2, delay: 2.8, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-[40px] sm:text-[64px] lg:text-[88px] leading-[0.95] mt-6 max-w-[1400px]"
          data-testid="and-yet-line-3"
        >
          <span className="text-white">We're </span>
          <span style={{ color: "#96C11F" }}>barely</span>
          <span className="text-white"> scratching</span>
          <br />
          <span className="text-white">the </span>
          <span
            style={{
              background: "linear-gradient(135deg, #96C11F 0%, #00deb6 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            surface.
          </span>
        </motion.h2>
      </div>
    </SceneShell>
  );
}
